import Modal from "react-bootstrap/Modal";
import { useState } from "react";
import SrvButton from "../../../components/global/SrvButton";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import ErrorAdd from "../../../util/ErrorAdd";

function ReferenceModalRemove({ show, onHide, idItem, name, update }) {

    const [log, setLog] = useState(null);
    const [loading, setLoading] = useState(false);
    const [archiveShow, setArchiveShow] = useState(false);

    function removeHandler() {
        setLoading(true);
        setLog(null);

        axios.post('/api_tracker/parameter/referenceRemove', { ID: idItem })
            .then((res) => {
                if (res.data.Status === 1) {
                    setLoading(false);
                    onHide();
                    update(idItem);
                }
                else {
                    setArchiveShow(true);
                    setLog(res.data.Error);
                    setLoading(false);
                }
            })
            .catch((err) => {
                setLog('Неизвестная ошибка!');
                setLoading(false);
                ErrorAdd(err, window.location.href);
            });
    }

    function archiveHandler() {
        setLoading(true);
        setLog(null);

        axios.post('/api_tracker/parameter/referenceArchive', { ID: idItem, Archive: true })
            .then((res) => {
                if (res.data.Status === 1) {
                    setLoading(false);
                    onHide();
                    update(idItem);
                }
                else {
                    setArchiveShow(true);
                    setLog(res.data.Error);
                    setLoading(false);
                }
            })
            .catch((err) => {
                setLog('Неизвестная ошибка!');
                setLoading(false);
                ErrorAdd(err, window.location.href);
            });
    }

    return (
        <>
            <Modal show={show} onHide={onHide}>
                <Modal.Body>
                    <div className="modal_close" onClick={onHide}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                    <div className="modal_title text-center mb-20">Удаление элемента справочника</div>
                    <div className="row" >
                        <div className="col-md-12 fs-5 text-center">
                            Подтвердите удаление элемента справочника <br></br>
                            <b>«{name}»</b>
                        </div>
                    </div>
                    {log !== null && <div className="form_error text-center mt-15">{log}</div>}
                    <div className="row mt-15">
                        <div className="col-md-12 text-center">
                            {archiveShow === true ? (
                                <SrvButton typeBtn="archive" loading={loading} size={'lg'} onClick={() => archiveHandler()} />
                            ) : (
                                <SrvButton typeBtn="remove" loading={loading} size={'lg'} onClick={() => removeHandler()} />
                            )}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}
export default ReferenceModalRemove;
